import React, { forwardRef, memo } from 'react'

const SendArrowIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="36.4"
      height="36.4"
      viewBox="0 0 52 52"
      fill="none"
      {...props}>
      <path
        d="M29.25 25.9998H16.25"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.84956 44.9472C9.7353 45.2593 9.71946 45.5989 9.80417 45.9202C9.88888 46.2415 10.0701 46.5291 10.3233 46.7443C10.5766 46.9595 10.8897 47.0918 11.2205 47.1235C11.5512 47.1552 11.8838 47.0848 12.1733 46.9216L46.2983 27.4033C46.5523 27.2628 46.764 27.0568 46.9114 26.8068C47.0588 26.5567 47.1366 26.2717 47.1366 25.9815C47.1366 25.6912 47.0588 25.4062 46.9114 25.1562C46.764 24.9061 46.5523 24.7001 46.2983 24.5596L12.1733 5.09005C11.8847 4.92863 11.5537 4.8591 11.2245 4.89077C10.8953 4.92243 10.5836 5.05378 10.3311 5.26726C10.0785 5.48075 9.8971 5.76621 9.81106 6.08552C9.72502 6.40483 9.73845 6.74279 9.84956 7.05427L16.25 25.9997L9.84956 44.9472Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

SendArrowIcon.displayName = 'SendArrowIcon'

export default memo(SendArrowIcon)
